import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    feed_count: 0,
    vehicle_count: 0,
    monthly_revenue: 0,
    total_exports: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await api.getStats();
        setStats(data);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  return (
    <div>
      <h2>Welcome, {user?.dealership_name || 'Dealer'}</h2>

      {!user?.platform_agreement_signed && (
        <div className="alert alert-warning">
          You must sign the platform agreement before you can license your inventory.
          <Link to="/agreement" style={{ marginLeft: '10px' }}>Sign Agreement</Link>
        </div>
      )}

      {user?.platform_agreement_signed && !user?.allow_syndication && (
        <div className="alert alert-warning">
          Enable inventory syndication in <Link to="/licensing">Licensing Settings</Link> to make your vehicles available to partners.
        </div>
      )}

      <div className="dashboard-grid">
        <div className="card stat-card">
          <div className="number">{loading ? '...' : stats.feed_count}</div>
          <div className="label">Active Feeds</div>
        </div>
        <div className="card stat-card">
          <div className="number">{loading ? '...' : stats.vehicle_count}</div>
          <div className="label">Vehicles Listed</div>
        </div>
        <div className="card stat-card">
          <div className="number">${loading ? '...' : stats.monthly_revenue.toFixed(2)}</div>
          <div className="label">This Month Revenue</div>
        </div>
        <div className="card stat-card">
          <div className="number">{loading ? '...' : stats.total_exports}</div>
          <div className="label">Total Exports</div>
        </div>
      </div>

      <div className="card" style={{ marginTop: '20px' }}>
        <h3>Account Status</h3>
        <p><strong>Status:</strong> <span className={`status status-${user?.account_status}`}>{user?.account_status}</span></p>
        <p><strong>Agreement:</strong> {user?.platform_agreement_signed ? 'Signed' : 'Not signed'}</p>
        <p><strong>Syndication:</strong> {user?.allow_syndication ? 'Enabled' : 'Disabled'}</p>
        <p><strong>Revenue Split:</strong> {user?.revenue_split_percentage || 70}% / {100 - (user?.revenue_split_percentage || 70)}%</p>
      </div>
    </div>
  );
}
